import { Routes } from '@angular/router';
import { userIsGGCCGuard } from '@core/guards/user-is-ggcc.guard';

export enum MyConsumptionRouteNames {
  MEASUREMENT_DOWNLOAD = 'measurement-download',
}

export const MY_CONSUMPTION_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/my-consumption/consumption/consumption.page').then((p) => p.ConsumptionPage),
    data: {
      breadcrumb: 'ROUTES.MY_CONSUMPTION',
    },
  },
  {
    path: MyConsumptionRouteNames.MEASUREMENT_DOWNLOAD,
    loadComponent: () =>
      import('@pages/my-consumption/measurement-download/measurement-download.page').then((p) => p.MeasurementDownloadPage),
    data: {
      breadcrumb: 'ROUTES.NEW_MEASURE',
    },
    canMatch: [userIsGGCCGuard],
  },
];
